var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWarning)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"form__col col input-desc",attrs:{"data-test-id":"warning"},domProps:{"innerHTML":_vm._s(_vm.$t('unmanagedBeneficiaryWarning'))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }